import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  GET_THERAPY_PLANNING_FAILURE,
  GET_THERAPY_PLANNING_REQUEST,
  GET_THERAPY_PLANNING_SUCCESS,
  GET_THERAPY_PLANNING_LOADING,
  GET_THERAPY_PLANNING_CANCEL_TOKEN,
} = therapyPlanningAction;

function* getTherapyPlanning(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_THERAPY_PLANNING_LOADING });
    const response = yield call(therapyPlanningService.getTherapyPlanning, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_THERAPY_PLANNING_SUCCESS, payload: response.data });
    } else {
      throw response;
    }
  } catch (error) {
    if (!error) yield put({ type: GET_THERAPY_PLANNING_CANCEL_TOKEN, payload: error });
    else yield put({ type: GET_THERAPY_PLANNING_FAILURE, payload: error });
  }
}

function* getTherapyPlanningSaga() {
  yield takeEvery(GET_THERAPY_PLANNING_REQUEST, getTherapyPlanning);
}

export default getTherapyPlanningSaga;
